import * as React from 'react';
import { t } from '@moovly/i18n';
import Page from '../../../components/Page';
import FontCreateButtonContainer from '../container/FontCreateButtonContainer';
import FontsTableContainer from '../container/FontsTableContainer';
import GroupSettingsProvider from '../container/GroupSettingsProvider';

const FontsPage: React.FC = () => (
  <Page header="fonts" title={t('fonts.title')} actions={<FontCreateButtonContainer />}>
    <FontsTableContainer />
  </Page>
);

export default FontsPage;
